console.log('js/mobile-menu.js -> v0.1.0');

$(() => {
	if (deviceType != 'Mobile') {
		return;
	}
	$('.js-mobile-menu').click(function () {
		$('.js-navbar__navs').toggleClass('flex')
	});
	const mobileFilterToggle = document.querySelector('a.js-filters__modal-toggle');
	mobileFilterToggle?.addEventListener('click', e => {
		e.preventDefault();
		e.stopPropagation();
		const modalel = mobileFilterToggle.getAttribute('href');
		$(modalel).modal('show');
	});
})
